import { AppStorage } from 'types';

const ENV = process.env;

const config = {
  app: {
    env: ENV.REACT_APP_ENV,
    version: ENV.REACT_APP_VERSION,
    url: ENV.REACT_APP_URL,
    publicUrl: ENV.PUBLIC_URL,
    commit: ENV.REACT_APP_COMMIT
  },
  language: {
    key: AppStorage.Local.LANGUAGE,
    initial: 'en',
    list: ['en']
  },
  sentry: {
    dsn: ENV.REACT_APP_SENTRY_DSN
  },
  agora: {
    appId: ENV.REACT_APP_AGORA_APP_ID
  },
  aws: {
    auth: {
      region: ENV.REACT_APP_AWS_REGION,
      userPoolId: ENV.REACT_APP_AWS_USER_POOL_ID,
      userPoolWebClientId: ENV.REACT_APP_AWS_CLIENT_ID,
      oauth: {
        domain: ENV.REACT_APP_AWS_OAUTH_DOMAIN,
        responseType: ENV.REACT_APP_AWS_OAUTH_REDIRECT_RESPONSE_TYPE,
        // @ts-ignore
        redirectSignIn:
          sessionStorage.getItem('ignoreCognitoRedirect') === 'true'
            ? undefined
            : ENV.REACT_APP_AWS_OAUTH_REDIRECT_SIGN_IN,
        // @ts-ignore
        redirectSignOut:
          sessionStorage.getItem('ignoreCognitoRedirect') === 'true'
            ? undefined
            : ENV.REACT_APP_AWS_OAUTH_REDIRECT_SIGN_OUT
      }
    }
  },
  api: {
    baseUrl: ENV.REACT_APP_API_BASE_URL
  },
  oauth: {
    google: {
      clientId: ENV.REACT_APP_GOOGLE_CLIENT_ID
    },
    twitch: {
      clientId: ENV.REACT_APP_TWITCH_CLIENT_ID
    }
  },
  rtmp: {
    youtube: {
      baseUrl: 'https://youtube.googleapis.com/youtube/v3'
    },
    facebook: {
      baseUrl: 'https://graph.facebook.com'
    },
    twitch: {
      baseUrl: 'https://api.twitch.tv/helix'
    }
  },
  mixpanel: {
    token: ENV.REACT_APP_MIXPANEL_TOKEN
  },
  ga: {
    measurementId: ENV.REACT_APP_GA_MEASUREMENT_ID
  },
  fingerprintjs: {
    apiKey: ENV.REACT_APP_FINGERPRINTJS_API_KEY
  },
  stripe: {
    publishableKey: ENV.REACT_APP_STRIPE_PUBLISHABLE_KEY
  },
  payme: {
    checkoutUrl: ENV.REACT_APP_PAYME_CHECKOUT_URL,
    merchantId: ENV.REACT_APP_PAYME_MERCHANT_ID
  },
  uzbekittv: {
    fee_in_uzs: ENV.REACT_APP_UZBEKITTV_FEE_IN_UZS
  }
};

export default config;
